
<div class="modal-header" *ngIf="links.length == 1" translate>Link ready</div>
<div class="modal-header" *ngIf="links.length &gt; 1" translate>Links ready</div>
<div class="modal-body">
  <div *ngFor="let link of links; let i = index" data-test-qa="sharedLink">
    <shared-link class="mb-4" [token]="link.token" id="sharingModal-link-{{i}}" (deleted)="onLinkDeleted(link)"></shared-link>
  </div>
  <div class="card bg-dark">
    <div class="card-body">
      <div class="form-group" *ngIf="!mailCount">
        <label translate>E-mail</label>
        <input class="form-control" type="email" [(ngModel)]="customEmail">
      </div>
      <div class="form-group">
        <label translate>Subject</label>
        <input class="form-control" type="text" [(ngModel)]="mailSubject">
      </div>
      <div class="form-group">
        <label translate>Personalized message</label>
        <textarea class="form-control" [(ngModel)]="mailText"></textarea>
      </div>
      <div class="mt-4 d-flex btn-toolbar">
        <div class="ml-auto"></div>
        <button class="btn btn-outline-primary" [clickBlocking]="sendEmails" data-test-qa="sendEmailsButton"><i class="far fa-paper-plane"></i><span [translate]="sendEmailsPlural" [translateParams]="{count: mailCount}"></span></button>
        <button class="btn btn-outline-secondary" (click)="modalInstance.close()" data-test-qa="closeButton" translate>Close</button>
      </div>
    </div>
  </div>
</div>